import { AST } from '@handlebars/parser';
import { getMustacheStatementFromStatement } from './getMustacheStatementFromStatement';
import { getSnippetMustacheStatement } from './getSnippetMustacheStatement';

export const getHandlebarsSnippetTagFromStatement = (statement: AST.Statement | null) => {
  const mustacheStatement = getMustacheStatementFromStatement(statement);
  const snippetMustacheStatement = getSnippetMustacheStatement(mustacheStatement);
  return snippetMustacheStatement;
};
